<template>
    <div v-if="route == null" v-bind:class="[tabName ? 'tab-item' : 'wbtn theme-svg', { 'accent-svg': isSelected && !tabName, 'active-tab-item': isSelected && tabName, disabled: isDisabled }]" @click="$emit('click')">
        <img v-if="!tabName" :src="this.getIconPath(this.icon)" />
        <span v-else class="tab-name">{{ tabName }}</span>
    </div>
    <router-link v-else :to="{name: route}" :class="tabName ? 'tab-item' : 'wbtn theme-svg'" :active-class="tabName ? 'active-tab-item' : 'accent-svg'">
        <img v-if="!tabName" :class="isBoldIcon ? 'bold-icon' : ''" :src="this.getIconPath(this.icon)" />
        <span v-else class="tab-name">{{ tabName }}</span>
    </router-link>
</template>
 
<script lang="ts">
    require('@/assets/portal.css');
    import { Component, Prop, Vue } from 'vue-facing-decorator';
    import { detectBasePath, resolveWithBase } from '@/utils/pathUtils';
    @Component({ emits: ['click'] })
    export default class NavigationTab extends Vue {
        @Prop({ default: false }) isSelected!: boolean;
        @Prop({ default: false }) isDisabled!: boolean;
        @Prop() icon!: string; // use absolute path to src svg instead of relative path
        @Prop({ default: null }) route!: string | null; // the name of the route to which the router-link navigates, if a router-link is desired
        @Prop({ default: false }) isBoldIcon!: boolean;
        @Prop({ default: null }) tabName!: string | null;

        private getIconPath(iconPath: string): string {
            return resolveWithBase(iconPath);
        }
    }
</script>

<style scoped>
    .bold-icon {
        width: 16px !important;
        height: 16px !important;
    }

    .tab-item {
        display: flex;
        align-items: center;
        padding: 8px 16px;
        cursor: pointer;
        border-bottom: 2px solid transparent;
    }

    .tab-item:hover {
        border-bottom-color:#1947BA;
    }

    .active-tab-item {
        border-bottom: 2px solid var(--accent-color);
    }

    .tab-name{
        font-size: 13px;
        font-weight: 600;
        color: var(--anaplan-background);
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .disabled {
        cursor: default;
        pointer-events: none;
        opacity: 0.5;
    }
</style>
